/**
 * Import and define sections pages
 * @note Since this is an 'apps' section, apps should be loaded alongside section pages and exported using the 'apps' 
 * const, so the list of apps can be used throughout the app.
 */
import * as defaultApp from "./default";
export const apps = [defaultApp];
export const pages = [...apps];